<template>
  <div>
    <div @click="showAcountModal" class="acount">
      <b-avatar :src="profile.userImage" size="30px" class="mr-2"/>
      <div class="d-flex align-items-center">
        {{profile.firstName}}
        {{profile.middleName}}
        {{profile.lastName}}
      </div>
    </div>
    <transition>
      <div class="acount-modal"
        v-show="isShowAcountModal"
        @mouseleave="closeAcountModal"
      >
        <div class="acount-modal__info">
          <b-avatar :src="profile.userImage" size="50px" class="mr-2"/>
          <div class="d-flex flex-column justify-content-center">
            <div class="mb-1">
              {{profile.firstName}}
              {{profile.middleName}}
              {{profile.lastName}}
            </div>
            <div class="acount-modal__user-email">{{profile.email1}}</div>
          </div>
        </div>
        <div class="acount-list">
          <h6 class="ml-2 font-weight-bold">{{profile.authority}}</h6>
          <router-link
            v-if="hasAuth(['senior'])"
            class="acount-list__list-item"
            @click="closeAcountModal"
            :to="{name: 'TutorDetail', params: { id: profile.id } }"
          >
            <b-avatar icon="person-fill" size="25px" class="mr-2 iconColor"/>
            <span class="d-flex align-items-center">My profile</span>
          </router-link>
          <router-link
            class="acount-list__list-item"
            @click="closeAcountModal"
            :to="{name: 'Dashboard'}"
          >
            <b-avatar icon="person-circle" size="25px" class="mr-2 iconColor"/>
            <span class="d-flex align-items-center">MyPage Top</span>
          </router-link>
          <div class="acount-list__list-item" @click="logout">
            <b-avatar icon="arrow-bar-right" size="25px" class="mr-2 iconColor"/>
            <span class="d-flex align-items-center">Sign Out</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import { RootState } from '@/store/types'
import { Tutor } from '@/store/tutors/types';

export default Vue.extend({
  data: (): {
    isShowAcountModal: boolean
  } => ({
    isShowAcountModal: false,
  }),

  computed: {
    profile(): Tutor|null {
      return this.$store.state.auth.profile;
    },
  },

  methods: {
    showAcountModal(): void {
      this.isShowAcountModal = true;
    },
    closeAcountModal(): void {
      this.isShowAcountModal = false;
    },
    logout(): void {
      this.$store.dispatch('logout')
        .then(() => this.$router.push({ name: 'Login' }))
    },
    hasAuth(acceptRoles: string[]): boolean {
      const auth = (this.$store.state as RootState).auth.profile?.authority
      return _.indexOf(acceptRoles, auth) !== -1
    },
  },
});
</script>

<style scoped>
.acount{
  padding-right: 30px;
  display: flex;
  cursor: pointer;
}

.acount-modal {
  position: absolute;
  top:3rem;
  right:10px;
  background: #fff;
  box-shadow: 4px 5px 6px #C0C0C0;
}

.acount-modal__info {
  padding:10px;
  margin-bottom:10px;
  display: flex;
  border-bottom:2px solid #EFEFEF;
}

.acount-list__list-item {
  display: flex;
  padding:15px;
  cursor: pointer;
  text-decoration: none;
  color: #000;
}

.acount-list__list-item:hover {
  background: #B3C6E7;
  color:#fff;
}

.iconColor {
  background: #B3C6E7;
}

.acount-list__list-item p {
  display: flex;
  align-items: center;
}

.list-item-link {
  display: flex;
  align-items: center;
  color: #000;
  text-decoration: none;
}

.v-enter-active, .v-leave-active {
  transition: opacity .3s;
}

.v-enter, .v-leave-to {
  opacity: 0;
}

</style>
